import * as React from 'react';
// @tidal-export alias=./Documentation

import { Box, Table, TableBody, TableCell, TableRow, useTheme } from '@mui/material'
import { validateTidalLicense } from '@workwave-tidal/license-utils'
import type { CSSProperties, ReactNode } from 'react'

type PropsWithChildren = { children: ReactNode }

export type ContainerProps = PropsWithChildren & {
  bg?: CSSProperties['color']
  margin?: CSSProperties['margin']
  padding?: CSSProperties['padding']
  borderColor?: CSSProperties['borderColor']
  borderStyle?: CSSProperties['borderStyle']
  borderWidth?: CSSProperties['borderWidth']
  width?: CSSProperties['width']
  height?: CSSProperties['height']
}

export const Container = (props: ContainerProps) => {
  const theme = useTheme()
  const {
    margin = '0',
    padding = '0',
    children,
    borderColor = theme.palette.divider,
    borderStyle = 'solid',
    borderWidth = '4px',
    bg: background = theme.palette.background.default,
    width = 'unset',
    height = 'unset',
  } = props

  return (
    <Box sx={{ borderWidth, borderStyle, borderColor, background, margin, padding, width, height }}>{children}</Box>
  )
}

export const Docs = (props: PropsWithChildren) => {
  const { children } = props

  return (
    <Table>
      <TableBody>
        <TableRow>{children}</TableRow>
      </TableBody>
    </Table>
  )
}

export const DocsDescription = (props: PropsWithChildren) => {
  const { children } = props

  return (
    <>
      <TableCell
        width="400px"
        sx={{
          paddingRight: '10px',
          verticalAlign: 'top',
          '& p': {
            textAlign: 'justify',
          },
        }}
      >
        {children}
      </TableCell>
    </>
  )
}

export const DocsExample = (props: PropsWithChildren) => {
  const { children } = props

  return (
    <TableCell
      width="600px"
      sx={{
        verticalAlign: 'top',
      }}
    >
      {children}
    </TableCell>
  )
}

// #license-validation
validateTidalLicense()
